import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './SummarySection.scss';

const SummarySectionBody = ({
  children,
  className,
  ...props
}) => (
  <div className={cx('SummarySectionBody', className)} {...props}>
    {children}
  </div>
);

SummarySectionBody.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(
      PropTypes.element
    ),
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.string
    ),
  ]),
};

SummarySectionBody.defaultProps = {
  children: null,
  className: undefined,
};

export default SummarySectionBody;
